import React, { useEffect } from "react";
import { useState } from "react";
import { deleteToCart, editCart, getCartItem } from "../actions/storeActions";
import Loading from "../helpers/Loading";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import FeeDetail from "../components/Cart/FeeDetail";
import CartItems from "../components/Cart/CartItems";
import NoData from "../components/NoData";
import DeliveryDetail from "../components/Product/DeliveryDetail";
import Popup from "../helpers/Popup";
const Cart = () => {
  const [checkoutProducts, setCheckoutProducts] = useState([]);
  const [cartData, setCartData] = useState(null);
  const [paymentSetting, setPaymentSetting] = useState({
    type: "Pick up",
    rate: 5,
    message: "",
  });

  const dispatch = useDispatch();
  let totalPoints = 0;
  useEffect(() => {
    (async function getCartItems() {
      const data = await getCartItem();

      setCartData(data);
      // dispatch({ type: "ALL_CART_ITEM", payload: data });
    })();
    return () => {
      setCartData(null);
      setPaymentSetting(null);
    };
  }, []);

  const handleChange = (e, item) => {
    !checkoutProducts.some((prod) => prod._id === e.target.value)
      ? setCheckoutProducts([...checkoutProducts, item])
      : setCheckoutProducts([
          ...checkoutProducts.filter((prod) => prod._id !== e.target.value),
        ]);
  };

  const handleRemoveToCart = async (idx, id, total) => {
    if (total > 1) {
      cartData[idx].total -= 1;
      dispatch({ type: "REMOVE_TO_CART" });
      await editCart({ data: { id, idx, total: cartData[idx].total } });
    } else {
      setCartData([...cartData.filter((data) => data._id !== id)]);

      dispatch({ type: "REMOVE_TO_CART" });

      await deleteToCart({ id });
    }
  };

  const handleAddToCart = async (id, idx) => {
    cartData[idx].total += 1;
    dispatch({ type: "ADD_TO_CART_ADDER" });
    await editCart({ data: { id, idx, total: cartData[idx].total } });
  };

  if (cartData === null) return <Loading />;

  return (
    <>
      <Popup />
      <div className="cart_body">
        <div className="cart_container">
          {cartData.length > 0 ? (
            <div className="all_cart_item">
              <CartItems
                cartData={cartData}
                handleAddToCart={handleAddToCart}
                handleRemoveToCart={handleRemoveToCart}
                handleChange={handleChange}
              />

              <div className="message_details">
                <p className="detail_header">Message</p>
                <div className="detail">
                  <p>To Seller,</p>
                  <textarea
                    name="message"
                    id="message"
                    onChange={(e) =>
                      setPaymentSetting({
                        ...paymentSetting,
                        message: e.target.value,
                      })
                    }
                    placeholder="State your brief message in 100 characters Example:(Time and Date, Instruction etc.)"
                    maxLength={100}
                  ></textarea>
                </div>
              </div>
              <div className="type_of_payment">
                <p className="detail_header">Payment</p>
                <div className="detail column">
                  {/* <div className="align">
                  <input
                    type="radio"
                    value="Credit Card"
                    onChange={(e) =>
                      setPaymentSetting({
                        ...paymentSetting,
                        type: e.target.value,
                        rate: 0,
                      })
                    }
                    name="payment"
                    id="payment"
                  />
                  <p className="cash_on_delivery">Credit Card</p>
                </div> */}
                  <div className="align">
                    <input
                      type="radio"
                      value="Cash on Delivery"
                      onChange={(e) =>
                        setPaymentSetting({
                          ...paymentSetting,
                          type: e.target.value,
                          rate: 15,
                        })
                      }
                      name="payment"
                      id="payment"
                    />
                    <p className="cash_on_delivery">Cash on Delivery</p>
                  </div>
                  <div className="align">
                    <input
                      type="radio"
                      value="Pick up"
                      onChange={(e) =>
                        setPaymentSetting({
                          ...paymentSetting,
                          rate: 5,
                          type: e.target.value,
                        })
                      }
                      name="payment"
                      id="payment"
                      defaultChecked="true"
                    />

                    <p className="pickup"> Pick up</p>
                  </div>
                </div>
              </div>
              <DeliveryDetail />

              <div className="fee_details">
                <FeeDetail
                  checkoutProducts={checkoutProducts}
                  totalPoints={totalPoints}
                  service={paymentSetting}
                  setCartData={setCartData}
                />
              </div>
            </div>
          ) : (
            <NoData title=" Cart is empty!" type="cart" />
          )}
        </div>
      </div>
    </>
  );
};

export default Cart;
